export default class VanillaHeaderController {
  constructor(headerSelector) {
    this.header = document.querySelector(headerSelector);
    this.lastScrollY = window.pageYOffset;
    this.threshold = window.innerHeight;

    if (!this.header) return;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.bindEvents();
    this.onScroll();
  }

  bindEvents() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize);
  }

  onResize() {
    this.threshold = window.innerHeight;
    this.onScroll();
  }

  onScroll() {
    const currentScrollY = window.pageYOffset;

    if (currentScrollY >= this.threshold) {
      this.header.classList.add("is-hidden");
    } else {
      this.header.classList.remove("is-hidden");
    }

    if (currentScrollY < this.lastScrollY) {
      this.header.classList.add("is-active");
    } else if (currentScrollY > this.lastScrollY) {
      this.header.classList.remove("is-active");
    }

    this.lastScrollY = currentScrollY;
  }
}
